// Lightweight client-side diagnostics: reports JS errors + device user-agent to
// the backend so device-specific failures (e.g. white screen on certain phones)
// can be debugged remotely.
const BASE = process.env.REACT_APP_BACKEND_URL;
let sent = 0;

export function logClientError(kind, message, stack = "", extra = "") {
    if (sent > 40) return;
    sent += 1;
    const payload = {
        kind: String(kind || ""),
        message: String(message || ""),
        stack: String(stack || ""),
        extra: String(extra || ""),
        url: (typeof location !== "undefined" && location.href) || "",
        user_agent: (typeof navigator !== "undefined" && navigator.userAgent) || "",
    };
    try {
        const body = JSON.stringify(payload);
        const url = `${BASE}/api/client-logs`;
        if (navigator.sendBeacon) {
            const ok = navigator.sendBeacon(url, new Blob([body], { type: "application/json" }));
            if (ok) return;
        }
        fetch(url, { method: "POST", headers: { "Content-Type": "application/json" }, body, keepalive: true }).catch(() => {});
    } catch { /* ignore */ }
}

export function initErrorLogging() {
    if (typeof window === "undefined") return;
    window.addEventListener("error", (e) => {
        logClientError("window.onerror", e?.message, e?.error?.stack, `${e?.filename || ""}:${e?.lineno || ""}:${e?.colno || ""}`);
    });
    window.addEventListener("unhandledrejection", (e) => {
        const r = e?.reason;
        logClientError("unhandledrejection", (r && (r.message || String(r))) || "unknown", r && r.stack, "");
    });
    // Record device/browser on load (helps identify missing browser APIs)
    logClientError("page_load", "app loaded", "", `apis:createImageBitmap=${typeof createImageBitmap};toBlob=${typeof (document.createElement("canvas").toBlob)};ResizeObserver=${typeof ResizeObserver}`);
}
